import axios from 'axios';
import config from '../common/config';

/** Server agreement_type value (legacy id); covers all business customers, not only White Label. */
export const BUSINESS_BASIC_AGREEMENT_TYPE = 'business_basic_agreement';
export const BUSINESS_BASIC_AGREEMENT_VERSION = 'v2.0';

/**
 * Record acceptance of a legal agreement (audit fields filled server-side where applicable).
 * @param {string} apptoken JWT
 * @param {{ agreement_type: string, agreement_version: string, language: string, source: string, user_agent: string, phone?: string }} payload
 */
export function recordUserAgreement(apptoken, payload) {
  const formData = new FormData();
  formData.append('agreement_type', payload.agreement_type);
  formData.append('agreement_version', payload.agreement_version);
  formData.append('language', payload.language);
  formData.append('source', payload.source);
  if (payload.phone) {
    formData.append('phone', payload.phone);
  }
  if (payload.user_agent) {
    formData.append('user_agent', payload.user_agent);
  }
  return axios.post(`${config.config.ROOT_URL}/record_user_agreement`, formData, {
    headers: {
      Authorization: `Bearer ${apptoken}`,
    },
  });
}
